import { createSelector } from 'reselect'

export const getSavedFilters = createSelector(
  state => state && state.user && state.user.profile && state.user.profile.savedFilters &&
    state.user.profile.savedFilters.elements.length
    ? state.user.profile.savedFilters.elements : [],
  savedFilters => savedFilters
)
